import { render } from "./CreateDemand.component.vue?vue&type=template&id=473b708a"
import script from "./CreateDemand.component.vue?vue&type=script&lang=js"
export * from "./CreateDemand.component.vue?vue&type=script&lang=js"

import "./CreateDemand.component.vue?vue&type=style&index=0&id=473b708a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__